import type { Crumb } from "../breadcrumb";
import { parsePublicPathname } from "./paths";
import { languageDestination } from "./navigation";

const LABELS: Record<string, string> = {
  "/blog": "学习资源",
  "/blog/o-level-combined-science": "O-Level 综合科学",
  "/blog/korea-scholarships": "韩国奖学金",
  "/blog/japan-scholarships": "日本奖学金",
  "/blog/bursaries": "助学金资源",
  "/blog/scholarships": "奖学金资源",
  "/blog/scholarships/bond-free": "无服务合约奖学金指南",
  "/blog/scholarships/engineering-technology": "工程与科技奖学金",
  "/blog/scholarships/public-service": "PSC 与公共服务奖学金",
  "/blog/scholarships/healthcare": "医疗与社区护理奖学金",
  "/blog/scholarships/business": "商业与管理奖学金",
  "/blog/scholarships/computing": "计算机与数据分析奖学金",
  "/blog/scholarships/bonded": "附服务合约奖学金指南",
  "/blog/scholarship-interview-prep": "奖学金面试准备",
  "/blog/sec-g3-mathematics-notes":
    "O-Level 初等数学与 SEC G3 数学笔记（英文资源）",
  "/blog/sec-g3-additional-mathematics-notes":
    "O-Level 附加数学与 SEC G3 附加数学笔记（英文资源）",
  "/blog/sec-g3-physics-notes": "O-Level 物理与 SEC G3 物理笔记（英文资源）",
  "/blog/sec-g3-chemistry-notes": "O-Level 化学与 SEC G3 化学笔记（英文资源）",
  "/blog/sec-g3-biology-notes": "O-Level 生物与 SEC G3 生物笔记（英文资源）",
  "/blog/sec-g3-science-physics-chemistry-notes":
    "O-Level 综合科学（物理、化学）与 SEC G3 综合科学（物理、化学） K326 笔记（英文资源）",
  "/blog/sec-g3-science-physics-biology-notes":
    "O-Level 综合科学（物理、生物）与 SEC G3 综合科学（物理、生物） K327 笔记（英文资源）",
  "/blog/sec-g3-science-chemistry-biology-notes":
    "O-Level 综合科学（化学、生物）与 SEC G3 综合科学（化学、生物） K328 笔记（英文资源）",
  "/blog/ip-overview": "新加坡直通车课程（IP）学校指南",
  "/blog/ip-physics-upper-sec-notes": "IP 中学高年级物理笔记（英文资源）",
  "/blog/ip-chemistry-upper-sec-notes": "IP 中学高年级化学笔记（英文资源）",
  "/blog/ip-biology-upper-sec-notes": "IP 中学高年级生物笔记（英文资源）",
  "/blog/ip-amaths-upper-sec-notes": "IP 中学高年级附加数学笔记（英文资源）",
  "/blog/ip-emaths-upper-sec-notes": "IP 中学高年级初等数学笔记（英文资源）",
  "/blog/ip-maths-lower-sec-notes": "IP 中学低年级数学笔记（英文资源）",
  "/blog/ip-combined-sciences-lower-sec-notes":
    "IP 中学低年级综合科学笔记（英文资源）",

  "/blog/h2-maths-notes": "H2 数学笔记（英文资源）",
  "/blog/h2-physics-notes": "H2 物理笔记（英文资源）",
  "/blog/h2-chemistry-notes": "H2 化学笔记（英文资源）",
  "/blog/h2-biology-notes": "H2 生物笔记（英文资源）",
  "/blog/ib-diploma": "IB文凭课程",
  "/blog/igcse-cie-singapore": "Cambridge IGCSE（CIE）新加坡指南资源页",
  "/blog/cambridge-international-a-level":
    "Cambridge International AS及A Level数学与科学",
  "/blog/pearson-edexcel-international-gcse":
    "Pearson Edexcel International GCSE 数学与科学",
  "/blog/pearson-edexcel-international-advanced-level":
    "Pearson Edexcel International Advanced Level 数学与科学",
  "/blog/pearson-ial-biology-practicals":
    "Pearson Edexcel International Advanced Level 生物学实验技能",
  "/blog/pearson-ial-chemistry-practicals":
    "Pearson Edexcel International Advanced Level 化学实验技能",
  "/blog/pearson-ial-physics-practicals":
    "Pearson Edexcel International Advanced Level 物理学实验技能",

  "/blog/pearson-ial-biology-notes":
    "Pearson Edexcel International Advanced Level 生物学笔记",
  "/blog/pearson-ial-chemistry-notes":
    "Pearson Edexcel International Advanced Level 化学笔记",
  "/blog/pearson-ial-physics-notes":
    "Pearson Edexcel International Advanced Level 物理学笔记",

  "/blog/pearson-ial-mathematics-notes":
    "Pearson Edexcel International Advanced Level 数学笔记",
  "/blog/pearson-ial-further-mathematics-notes":
    "Pearson Edexcel International Advanced Level 进阶数学（Further Mathematics）笔记",
  "/blog/pearson-ial-pure-mathematics-notes":
    "Pearson Edexcel International Advanced Level 纯粹数学（Pure Mathematics）笔记",

  "/blog/cambridge-international-a-level-mathematics-notes":
    "Cambridge International AS及A Level 数学笔记",
  "/blog/cambridge-international-a-level-further-mathematics-notes":
    "Cambridge International AS及A Level 进阶数学（Further Mathematics）笔记",
  "/blog/cambridge-international-a-level-biology-practicals":
    "Cambridge International AS及A Level 生物学实验技能",
  "/blog/cambridge-international-a-level-chemistry-practicals":
    "Cambridge International AS及A Level 化学实验技能",
  "/blog/cambridge-international-a-level-physics-practicals":
    "Cambridge International AS及A Level 物理学实验技能",
  "/blog/cambridge-international-a-level-biology-notes":
    "Cambridge International AS及A Level 生物学笔记",
  "/blog/cambridge-international-a-level-chemistry-notes":
    "Cambridge International AS及A Level 化学笔记",
  "/blog/cambridge-international-a-level-physics-notes":
    "Cambridge International AS及A Level 物理学笔记",
  "/blog/igcse-mathematics-notes": "Cambridge IGCSE 数学笔记：0580及0980",
  "/blog/igcse-additional-mathematics-notes":
    "Cambridge IGCSE 附加数学（Additional Mathematics）笔记：0606",

  "/blog/igcse-combined-science-notes":
    "Cambridge IGCSE 综合科学（Combined Science）笔记：0653",
  "/blog/igcse-coordinated-sciences-notes":
    "Cambridge IGCSE 协调科学（Co-ordinated Sciences）笔记：0654及0973",

  "/blog/igcse-biology-notes": "Cambridge IGCSE 生物学笔记：0610及0970",
  "/blog/igcse-chemistry-notes": "Cambridge IGCSE 化学笔记：0620及0971",
  "/blog/igcse-physics-notes": "Cambridge IGCSE 物理学笔记：0625及0972",

  "/blog/pearson-igcse-biology-practicals":
    "Pearson Edexcel International GCSE 生物学实验技能",
  "/blog/pearson-igcse-chemistry-practicals":
    "Pearson Edexcel International GCSE 化学实验技能",
  "/blog/pearson-igcse-physics-practicals":
    "Pearson Edexcel International GCSE 物理学实验技能",
  "/blog/pearson-igcse-science-double-award-practicals":
    "Pearson Edexcel International GCSE 科学双成绩课程（Double Award）实验技能",

  "/blog/pearson-igcse-biology-notes":
    "Pearson Edexcel International GCSE 生物学笔记",
  "/blog/pearson-igcse-chemistry-notes":
    "Pearson Edexcel International GCSE 化学笔记",
  "/blog/pearson-igcse-physics-notes":
    "Pearson Edexcel International GCSE 物理学笔记",
  "/blog/pearson-igcse-science-double-award-notes":
    "Pearson Edexcel International GCSE 科学双成绩课程（Double Award）笔记",

  "/blog/pearson-igcse-mathematics-a-notes":
    "Pearson Edexcel International GCSE 数学A笔记",
  "/blog/pearson-igcse-further-pure-mathematics-notes":
    "Pearson Edexcel International GCSE 进阶纯数学（Further Pure Mathematics）笔记",

  "/blog/pearson-igcse-science-single-award-practicals":
    "Pearson Edexcel International GCSE 科学单成绩课程（Science Single Award）实验技能笔记",
  "/blog/pearson-igcse-human-biology-practicals":
    "Pearson Edexcel International GCSE 人体生物学实验技能笔记",

  "/blog/pearson-igcse-mathematics-b-notes":
    "Pearson Edexcel International GCSE 数学B笔记",
  "/blog/pearson-igcse-science-single-award-notes":
    "Pearson Edexcel International GCSE 科学单成绩课程（Science Single Award）笔记",
  "/blog/pearson-igcse-human-biology-notes":
    "Pearson Edexcel International GCSE 人体生物学笔记",

  "/blog/igcse-international-mathematics-notes": "Cambridge IGCSE 国际数学笔记",
  "/blog/igcse-statistics-notes": "Cambridge IGCSE 统计学笔记",
  "/blog/igcse-environmental-management-notes": "Cambridge IGCSE 环境管理笔记",
  "/blog/igcse-marine-science-notes": "Cambridge IGCSE 海洋科学笔记",
  "/blog/cambridge-international-as-environmental-management-notes":
    "Cambridge International AS Level 环境管理笔记",
  "/blog/cambridge-international-a-level-marine-science-notes":
    "Cambridge International AS及A Level 海洋科学笔记",
  "/blog/cambridge-international-as-environmental-management-investigations":
    "Cambridge International AS Level 环境管理探究",
  "/blog/cambridge-international-a-level-marine-science-practicals":
    "Cambridge International AS及A Level 海洋科学实验技能",
  "/blog/igcse-environmental-management-fieldwork":
    "Cambridge IGCSE 环境管理实地调查",
  "/blog/igcse-marine-science-practicals": "Cambridge IGCSE 海洋科学实验技能",
  "/blog/igcse-combined-science-experiments": "Cambridge IGCSE 综合科学实验",
  "/blog/igcse-coordinated-sciences-experiments":
    "Cambridge IGCSE 协调科学实验",
  "/blog/igcse-physics-experiments": "Cambridge IGCSE 物理实验",
  "/blog/igcse-chemistry-experiments": "Cambridge IGCSE 化学实验",
  "/blog/igcse-biology-experiments": "Cambridge IGCSE 生物实验",
  "/blog/h2-physics-experiments": "H2 物理实验课程",
  "/blog/h2-chemistry-experiments": "H2 化学实验课程",
  "/blog/h2-biology-experiments": "H2 生物实验课程",
  "/blog/o-level-physics-experiments": "O-Level 物理实验课程",
  "/blog/o-level-chemistry-experiments": "O-Level 化学实验课程",
  "/blog/o-level-biology-experiments": "O-Level 生物实验课程",
  "/blog/o-level-combined-science-practicals": "O-Level 综合科学实验课程",
  "/blog/o-level-science-physics-practical": "O-Level 综合科学物理实验课程",
  "/blog/o-level-science-chemistry-practical": "O-Level 综合科学化学实验课程",
  "/blog/o-level-science-biology-practical": "O-Level 综合科学生物实验课程",

  "/blog/ip-science-practicals": "IP 科学实验课程",
  "/blog/ip-lower-secondary-science-practicals":
    "IP 中学低年级综合科学实验课程",
  "/blog/ip-physics-practicals": "IP 物理实验课程",
  "/blog/ip-chemistry-practicals": "IP 化学实验课程",
  "/blog/ip-biology-practicals": "IP 生物实验课程",
  "/blog/ip-lower-secondary-maths-tuition": "IP 中学低年级数学补习",
  "/blog/ip-lower-secondary-science-tuition": "IP 中学低年级科学补习",
  "/blog/ip-upper-secondary-maths-tuition": "IP 中学高年级数学补习",
  "/blog/ip-upper-secondary-physics-tuition": "IP 中学高年级物理补习",
  "/blog/ip-upper-secondary-chemistry-tuition": "IP 中学高年级化学补习",
  "/blog/ip-upper-secondary-biology-tuition": "IP 中学高年级生物补习",
  "/blog/o-level-biology-tuition": "O-Level 生物补习",
  "/blog/o-level-chemistry-tuition": "O-Level 化学补习",
  "/blog/o-level-physics-tuition": "O-Level 物理补习",
  "/blog/secondary-physics-tuition": "中学物理补习",
  "/blog/physics-tuition": "物理补习",
  "/blog/ip-maths-tuition": "IP 数学补习",
  "/blog/ip-physics-tuition": "IP 物理补习",
  "/blog/ip-chemistry-tuition": "IP 化学补习",
  "/blog/chemistry-tuition": "化学补习",
  "/blog/maths-tuition": "数学补习",
  "/blog/biology-tuition": "生物补习",
  "/blog/ip-biology-tuition": "IP 生物补习",
  "/blog/a-level-maths-tuition": "A-Level 数学补习",
  "/blog/a-level-physics-tuition": "A-Level 物理补习",
  "/blog/a-level-chemistry-tuition": "A-Level 化学补习",
  "/blog/a-level-biology-tuition": "A-Level 生物补习",
};

/** Explicit dispatch boundary; unsupported cohorts retain their own translation work. */
export function hasMandarinProgrammeBreadcrumb(pathname: string): boolean {
  const parsed = parsePublicPathname(pathname);
  return (
    parsed.locale === "zh-Hans" && Object.hasOwn(LABELS, parsed.contentPathname)
  );
}

/** Draft labels do not confer publication eligibility on their routes. */
export function mandarinProgrammeBreadcrumbs(pathname: string): Crumb[] {
  const parsed = parsePublicPathname(pathname);
  const label = LABELS[parsed.contentPathname];
  if (parsed.locale !== "zh-Hans" || !label) {
    throw new Error(`Missing Mandarin programme breadcrumb: ${pathname}`);
  }
  if (parsed.contentPathname === "/blog") return [
    { name: "首页", href: "/zh", position: 1 },
    { name: label, href: "/zh/blog", position: 2 },
  ];
  const resources = languageDestination("/blog", "zh-Hans");
  return [
    { name: "首页", href: "/zh", position: 1 },
    {
      name: resources === "/blog" ? "学习资源（英文页面）" : "学习资源",
      href: resources,
      position: 2,
    },
    { name: label, href: pathname, position: 3 },
  ];
}
